import {
	Component, Input, Output, EventEmitter, SimpleChanges, OnDestroy,
	OnChanges
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettings, ProtocolSettingsTypes, PrtgSettings } from 'DiscoveryEngine.TS/Protocols';
import { Guid, StringUtils } from "DiscoveryEngine.TS/Utils";
import { ComponentBase, Changeable } from "common";
import { NavigationService } from 'netview';
import { DiscResultsService } from 'discovery';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { IdentityService, LicensingService } from 'identity';
import { MessageService } from 'base';
import { ToolsService } from 'tools';
import { HaloExport } from 'DiscoveryEngine.TS/Export/HaloExport';
import { ConfigurationService } from '../../../configuration';
import { AgentDto } from '../../../UvExplorerServer.Dtos.TS/Agents';
import { ScheduledDiscovery } from '../../../DiscoveryEngine.TS/Discovery';


@Component({
	selector: 'halo-export-config',
	templateUrl: '../halo-export-config/halo-export-config.component.html',
	styleUrls: ['../halo-export-config/halo-export-config.component.scss']
})
export class HaloExportConfigComponent extends ComponentBase implements OnDestroy, OnChanges, Changeable {

	@Input()
	public Network: NetViewDto;

	@Input()
	public HaloExport: HaloExport;

	@Input()
	public Agent: AgentDto;

	@Input()
	public ScheduledDiscovery: ScheduledDiscovery;

	@Input()
	public EnableExportOrigin: boolean;

	public SettingsForm: UntypedFormGroup;

	public EnableExport: UntypedFormControl;

	public TargetServerApiURL: UntypedFormControl;
	public TargetServerClientID: UntypedFormControl;
	public TargetServerUsername: UntypedFormControl;
	public TargetServerPassword: UntypedFormControl;
	public UseMacAddressLookup: UntypedFormControl;
	public UseIpAddressLookup: UntypedFormControl;

	public ClientName: UntypedFormControl;
	public SiteName: UntypedFormControl;

	public ExportOrigin: UntypedFormControl;

	public ExportDevices: UntypedFormControl;
	public ExportConfigs: UntypedFormControl;
	public ExportDependencies: UntypedFormControl;
	public ExportMapToLocation: UntypedFormControl;

	public MapFileName: UntypedFormControl;
	public MapFileExtension: UntypedFormControl;

	private apiUsernameChanged: boolean;
	private apiUsernameChangedSub: Subscription;

	private apiPasswordChanged: boolean;
	private apiPasswordChangedSub: Subscription;

	private apiClientIdChanged: boolean;
	private apiClientIdChangedSub: Subscription;


	public mapDropdownOptions: string[];

	constructor(private fb: UntypedFormBuilder,
		private navService: NavigationService,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private messageService: MessageService,
		private configService: ConfigurationService,
		private toolsService: ToolsService) {

		super();

		this.Network = null;
		this.HaloExport = null;
		this.EnableExportOrigin = false;

		this.mapDropdownOptions = HaloExport.mapFormatDropdownOptions;
	}

	public ngOnDestroy(): void {
		if (this.apiUsernameChangedSub) {
			this.apiUsernameChangedSub.unsubscribe();
		}
		if (this.apiPasswordChangedSub) {
			this.apiPasswordChangedSub.unsubscribe();
		}
		if (this.apiClientIdChangedSub) {
			this.apiClientIdChangedSub.unsubscribe();
		}
	}

	public get isLicenseValid(): boolean {
		//return this.licensingService.isLicenseValid;
		return true;
	}

	protected BuildForm(): void {

		let enableExport = false;

		// Halo settings
		let serverURL = "";
		let serverClientID = "";
		let serverUsername = "";
		let serverPassword = "";
		let useMacAddressLookup = false;
		let useIpAddressLookup = false;
		let clientName = "";
		let siteName = "";

		let exportOrigin = "";

		let exportDevices = false;
		let exportConfigs = false;
		let exportDependencies = false;
		let exportMapToLocation = false;

		let mapFilename = "";
		let mapFileExt = "";

		if (this.HaloExport) {
			let value = this.HaloExport;

			enableExport = value.EnableExport;

			if (value.HasTargetServerApiURL)
				serverURL = value.TargetServerApiURL;
			if (value.HasTargetServerClientID) {
				if (StringUtils.IsObfuscatedString(value.TargetServerClientID)) {
					serverClientID = this.hidePassword(value.TargetServerClientID);
				}
				else {
					serverClientID = value.TargetServerClientID;
				}
			}
			if (value.HasTargetServerUsername)
				serverUsername = value.TargetServerUsername;
			if (value.HasTargetServerPassword) {
				if (StringUtils.IsObfuscatedString(value.TargetServerPassword)) {
					serverPassword = this.hidePassword(value.TargetServerPassword);
				}
				else {
					serverPassword = value.TargetServerPassword;
				}
			}
			if (value.UseMacAddressLookup)
				useMacAddressLookup = value.UseMacAddressLookup;
			if (value.UseIpAddressLookup)
				useIpAddressLookup = value.UseIpAddressLookup;
			if (value.HasClientName)
				clientName = value.ClientName;
			if (value.HasSiteName)
				siteName = value.SiteName;

			if (value.HasExportOrigin)
				exportOrigin = value.ExportOrigin;

			exportDevices = value.ExportDevices;
			exportConfigs = value.ExportConfigs;
			exportDependencies = value.ExportDependencies;
			exportMapToLocation = value.ExportMapToNetwork;

			mapFilename = value.MapFilename;
			mapFileExt = value.MapFileExtension;
		}

		this.EnableExport = new UntypedFormControl(enableExport);

		this.TargetServerApiURL = new UntypedFormControl(serverURL);
		this.TargetServerClientID = new UntypedFormControl(serverClientID);
		this.TargetServerUsername = new UntypedFormControl(serverUsername);
		this.TargetServerPassword = new UntypedFormControl(serverPassword);
		this.UseMacAddressLookup = new UntypedFormControl(useMacAddressLookup);
		this.UseIpAddressLookup = new UntypedFormControl(useIpAddressLookup);
		this.ClientName = new UntypedFormControl(clientName);
		this.SiteName = new UntypedFormControl(siteName);

		this.ExportOrigin = new UntypedFormControl(exportOrigin);

		this.ExportDevices = new UntypedFormControl(exportDevices);
		this.ExportConfigs = new UntypedFormControl(exportConfigs);
		this.ExportDependencies = new UntypedFormControl(exportDependencies);
		this.ExportMapToLocation = new UntypedFormControl(exportMapToLocation);

		this.MapFileName = new UntypedFormControl(mapFilename);
		this.MapFileExtension = new UntypedFormControl(mapFileExt);

		this.apiUsernameChanged = false;
		this.apiUsernameChangedSub = this.TargetServerUsername.valueChanges.subscribe(() => {
			this.apiUsernameChanged = true;
		});

		this.apiPasswordChanged = false;
		this.apiPasswordChangedSub = this.TargetServerPassword.valueChanges.subscribe(() => {
			this.apiPasswordChanged = true;
		});

		this.apiClientIdChanged = false;
		this.apiClientIdChangedSub = this.TargetServerClientID.valueChanges.subscribe(() => {
			this.apiClientIdChanged = true;
		});

		this.SettingsForm = this.fb.group({
			EnableExport: this.EnableExport,
			TargetServerApiURL: this.TargetServerApiURL,
			TargetServerUsername: this.TargetServerUsername,
			TargetServerPassword: this.TargetServerPassword,
			TargetServerClientID: this.TargetServerClientID,
			UseMacAddressLookup: this.UseMacAddressLookup,
			UseIpAddressLookup: this.UseIpAddressLookup,
			ClientName: this.ClientName,
			SiteName: this.SiteName,
			ExportOrigin: this.ExportOrigin,
			ExportDevices: this.ExportDevices,
			ExportConfigs: this.ExportConfigs,
			ExportDependencies: this.ExportDependencies,
			ExportMapToLocation: this.ExportMapToLocation,
			MapFileName: this.MapFileName,
			MapFileExtension: this.MapFileExtension,
		},
		{
			validator: Validators.compose([
				this.validHaloSettings(this.EnableExport, this.TargetServerApiURL, this.TargetServerClientID, this.TargetServerUsername, this.TargetServerPassword, this.ClientName)

				// Group Name is now optional
				//this.validGroupName(this.EnableExport, this.GroupName)
			])
		});
	}

	public get ExportEnabled(): boolean {
		if (this.EnableExport) {
			return this.EnableExport.value;
		}
		else {
			return false;
		}
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public get tempChanges(): boolean {
		return this.SettingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.SettingsForm.valid;
	}

	public discardTempChanges(): void {
		this.BuildForm();
	}

	public applyTempChanges(): void {
		if (this.HaloExport) {
			let value = this.HaloExport;

			value.EnableExport = this.EnableExport.value;

			value.TargetServerApiURL = this.TargetServerApiURL.value;

			if (this.apiUsernameChanged) {
				value.TargetServerUsername = this.TargetServerUsername.value;
			}
			if (this.apiPasswordChanged) {
				value.TargetServerPassword = StringUtils.ObfuscateString2(this.TargetServerPassword.value);
			}
			if (this.apiClientIdChanged) {
				value.TargetServerClientID = StringUtils.ObfuscateString2(this.TargetServerClientID.value);
			}
			value.UseMacAddressLookup = this.UseMacAddressLookup.value;
			value.UseIpAddressLookup = this.UseIpAddressLookup.value;
			value.ClientName = this.ClientName.value;
			value.SiteName = this.SiteName.value;

			value.ExportOrigin = this.ExportOrigin.value;

			value.ExportDevices = this.ExportDevices.value;
			value.ExportConfigs = this.ExportConfigs.value;
			value.ExportDependencies = this.ExportDependencies.value;
			value.ExportMapToNetwork = this.ExportMapToLocation.value;

			value.MapFilename = this.MapFileName.value;
			value.MapFileExtension = this.MapFileExtension.value;
			
			this.BuildForm();
		}
	}

	public onUsernameKeyDownHandler(event: any): void {
		if (!this.apiUsernameChanged) {
			this.apiUsernameChanged = true;

			this.TargetServerUsername.setValue('');
			this.TargetServerUsername.markAsDirty();
		}
	}

	public onPasswordKeyDownHandler(event: any): void {
		if (!this.apiPasswordChanged) {
			this.apiPasswordChanged = true;

			this.TargetServerPassword.setValue('');
			this.TargetServerPassword.markAsDirty();
		}
	}

	public onClientIdKeyDownHandler(event: any): void {
		if (!this.apiClientIdChanged) {
			this.apiClientIdChanged = true;

			this.TargetServerClientID.setValue('');
			this.TargetServerClientID.markAsDirty();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Halo Export"];
	}

	private validHaloSettings(enableExport: UntypedFormControl, serverApiURL: UntypedFormControl, serverApiClientId: UntypedFormControl, serverApiUsername: UntypedFormControl, serverApiPassword: UntypedFormControl, client: UntypedFormControl): ValidatorFn {
		return () => {
			if (enableExport.value) {
				if (!serverApiURL.value) {
					return {
						validHaloSettings: { valid: false }
					};
				}
				else if (!serverApiUsername.value) {
					return {
						validHaloSettings: { valid: false }
					};
				}
				else if (!serverApiPassword.value) {
					return {
						validHaloSettings: { valid: false }
					};
				}
				else if (!serverApiClientId.value) {
					return {
						validHaloSettings: { valid: false }
					};
				}
				else if (!client.value) {
					return {
						validHaloSettings: { valid: false }
					};
				}
				else {
					return null;
				}
			}
		}
	}


	private validClient(enableExport: UntypedFormControl, client: UntypedFormControl): ValidatorFn {
		return () => {
			if (enableExport.value) {
				if (!client.value) {
					return {
						validClient: { valid: false }
					};
				}
				else {
					return null;
				}
			}
		}
	}

	public ExportNow(): void {
		if (this.tempChanges) {
			this.messageService.displayInfoMessage(
				"You have unsaved changes to your Halo export settings.\nPlease save before exporting.", 10000);
		}
		else {
			if (!!this.Network && !!this.Network.Guid) {
				let sessionGuid = this.identityService.sessionGuid;
				let netViewGuid = this.Network.Guid;
				let agentGuid = this.navService.location.agentGuid;
				let schedDiscGuid = this.navService.location.schedDiscGuid;
				this.discResultsService.runHaloExport(sessionGuid, netViewGuid, agentGuid, schedDiscGuid).subscribe(
					(result: boolean) => {
						this.messageService.displayInfoMessage("Halo Export has been initiated");
					},
					(error) => {
						this.messageService.displayErrorMessage("Halo Export failed");
					});
			}
		}
	}

	public get enableTestHaloButton(): boolean {
		return (
			!!this.TargetServerApiURL && !!this.TargetServerApiURL.value &&
			!!this.TargetServerClientID && !!this.TargetServerClientID.value &&
			!!this.TargetServerUsername && !!this.TargetServerUsername.value &&
			!!this.TargetServerPassword && !!this.TargetServerPassword.value);
	}

	public testHaloConnect(): void {
		let apiURL = this.TargetServerApiURL.value;
		let apiClientID = this.TargetServerClientID.value;
		let apiUsername = "";
		let apiPassword = "";
		if (this.apiUsernameChanged) {
			apiUsername = this.TargetServerUsername.value;
		}
		else {
			apiUsername = this.HaloExport.TargetServerUsername;
		}
		if (this.apiPasswordChanged) {
			apiPassword = StringUtils.ObfuscateString2(this.TargetServerPassword.value);
		}
		else {
			apiPassword = this.HaloExport.TargetServerPassword;
		}
		if (this.apiClientIdChanged) {
			apiClientID = StringUtils.ObfuscateString2(this.TargetServerClientID.value);
		}
		else {
			apiClientID = this.HaloExport.TargetServerClientID;
		}

		this.configService.testHaloConnection(apiURL, apiClientID, apiUsername, apiPassword).subscribe(
			() => {
				this.messageService.displayInfoMessage("Successfully connected to Halo");
			},
			(error) => {
				this.messageService.displayErrorMessage("Failed to connect to Halo");
			});
	}
}
